// extracted by mini-css-extract-plugin
module.exports = {"im-cust":"_3UGF9qt5LF6UEJIf0OyVQE"};